import {ReportConfig} from './REPORT_CONFIG';
import {TabbedFilterItemValue} from './TABBED_FILTERS_CONFIG';
import {EventEmitter} from '@angular/core';


export const DiscoveryUtilFunctions = {
  getFilterStrings: function(
    currentConfig: ReportConfig,
    selectedFilterValues: TabbedFilterItemValue[],
    cannedreports: Array<any>,
    bulkUploadReportId: string,
    currentCannedReportUpdater: EventEmitter<any>,
    importedFileNameUpdater: EventEmitter<any>,
    noMainFilters?: boolean,
    noSortBy?: boolean) {
    const filterStrings: Array<string> = [];

    if (!noMainFilters) {
      currentConfig.mainFilterItems.filter((item) => !item.ignore).forEach(mainfilter => {
        // mainfilter.selected.values.forEach(value => {
        //     filterStrings.push(`${mainfilter.param}=${value}`);
        // });

        const value = mainfilter.selected.apiValue;

        if (!mainfilter.selected.ignore) {
          if (value && value.length) {
            if (value.indexOf(',') > 0) {
              const values = value.split(',');
              values.forEach((v) => {
                filterStrings.push(`${mainfilter.apiKey}=${v}`);
              });
            } else {
              filterStrings.push(`${mainfilter.apiKey}=${value}`);
            }
          }
        }

      });
    }

    if (!noSortBy) {
      let sortByValue = currentConfig.gridHeaders
        .filter(header => header.sort && header.sort.length > 0 && header.sortColumnKey)
        .map(header => header.sortColumnKey.concat(header.sort === 'sort-desc' ? ' DESC' : ''))
        .join(',');

      if (sortByValue && sortByValue.indexOf('bidRange') >= 0) {
        sortByValue = sortByValue.replace('bidRange', 'priceBidLow');
      }

      if (sortByValue && sortByValue.length > 0) {
        filterStrings.push(`sortBy=${sortByValue}`);
      }
    }



    if (selectedFilterValues && selectedFilterValues.length > 0) {
      selectedFilterValues.forEach(filterValue => {
        const filterValueString = encodeURIComponent(filterValue.value);
        filterStrings.push(`${filterValue.param}=${filterValueString}`);
      });
    }

    let foundcannedreport = false;
    if (cannedreports && cannedreports.length > 0) {
      cannedreports.forEach((report) => {
        report.reports.forEach((subreport) => {
          const filters = subreport.filters;
          const mainfilters = subreport.mainFilters;
          let matched = true;
          const filterkeys = filters ? Object.keys(filters) : [];
          const mainFilterKeys = mainfilters ? Object.keys(mainfilters) : [];

          if (mainFilterKeys && filterkeys && mainFilterKeys.length > 0 && filterkeys.length > 0) {
            filterkeys.forEach((filterkey) => {
              if (selectedFilterValues && selectedFilterValues.length > 0) {
                const found = selectedFilterValues.filter((selected) => selected.param === filterkey && selected.value === filters[filterkey]);
                if (found && found[0]) {
                  // Do Nothing
                } else {
                  matched = false;
                }
              }

            });

            mainFilterKeys.forEach((mainFilterKey) => {
              const found = currentConfig.mainFilterItems.filter((mainFilterItem) => mainFilterItem.apiKey === mainFilterKey);
              if(found && found[0]) {
                if (found[0].selected.value === subreport.mainFilters[mainFilterKey]) {
                  // Do nothing
                } else {
                  matched = false;
                }
              } else {
                matched = false;
              }
            });
          } else if (mainFilterKeys.length > 0 && filterkeys.length <= 0) {
            mainFilterKeys.forEach((mainFilterKey) => {
              const found = currentConfig.mainFilterItems.filter((mainFilterItem) => mainFilterItem.apiKey === mainFilterKey);
              if(found && found[0]) {
                if (found[0].selected.value === subreport.mainFilters[mainFilterKey]) {
                  // Do nothing
                } else {
                  matched = false;
                }
              } else {
                matched = false;
              }
            });
          } else if (filterkeys.length > 0 && mainFilterKeys.length <= 0) {
            filterkeys.forEach((filterkey) => {
              const found = selectedFilterValues.filter((selected) => selected.param === filterkey && selected.value === filters[filterkey]);
              if(found && found[0]) {
                // Do Nothing
              } else {
                matched = false;
              }
            });
          } else {
            matched = false;
          }

          if (selectedFilterValues && selectedFilterValues.length > 0) {
            subreport.active = matched && (Object.keys(subreport.filters).length === selectedFilterValues.length);
          }

          if (matched) {
            report.collapsed = false;
            foundcannedreport = true;
            // report.headertitle = this.currentCannedReport.title + ' - ' + subreport.title;
            currentCannedReportUpdater.emit(report);
          }
        });
      });
    }

    if (!foundcannedreport) {
      currentCannedReportUpdater.emit(null);
    }

    // const bulkUploadReportId = this._route.snapshot.queryParams['bulkUploadReportId'];
    if (bulkUploadReportId) {
      filterStrings.push(`bulkUploadReportId=${bulkUploadReportId}`);
    } else {
      // this.importedFileName = null;
      importedFileNameUpdater.emit(null);
    }

    return filterStrings;
  }
}

